import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
export default function Gamessection({ className = "" }) {
  return (
    <div className={`${styles["game-wrapper"]} ${className}`}>
      <div className={`${styles["game-card"]} ${styles["game-card-column"]}`}>
        <Link href="https://games.vikatan.com?pfrom=homepage-mainrow-games">
          <img
            src="https://media.vikatan.com/vikatan/2025-09-10/g0xmfmae/vikatan-game-new-logo2x.png?w=200"
            alt="Vikatan Games"
            width="177px"
            height="52px"
          />
        </Link>
      </div>
      <div className={`${styles["game-card"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2025-12-06/vmkmyapx/VikatanSolThedallogo.png?w=300"
          alt="solthedal"
          width="126px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/solthedal?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={`${styles["game-card"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2025-11-10/p5yyeix3/VikatanGameMaraiSollogo.png?w=300"
          alt="Flip Game"
          width="124px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/letter-flip?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2022-09/bb09acda-624b-43d9-82ce-0914e6a76982/Logo_2e6798cafbd8614a0664.png?w=300"
          alt="சொல்லியடி"
          width="115px"
          height="38px"
        />
        <Link href="https://solliyadi.vikatan.com?pfrom=homepage-mainrow-games" className={styles["cta-btn"]} target="">
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2022-09/27138631-7943-4e89-a7fa-092888cc4cec/solvettai_logo.png?w=300"
          alt="சொல் வேட்டை"
          width="104px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/word-search?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2022-09/851222c6-6bb6-4136-ae87-dc4128abe039/logo_876c56c8971a2655d6dd.png?w=300"
          alt="வார்த்தையோடு விளையாடு"
          width="143px"
          height="38px"
        />
        <Link
          href="https://games.vikatan.com/varthaiyodu-vilaiyadu?pfrom=homepage-mainrow-games"
          className={styles["cta-btn"]}
        >
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2025-09-10/a5zz2lat/20482x.png?w=300"
          alt="2048"
          width="116px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/2048?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2025-09-10/6pi03edh/watchout2x.png?w=300"
          alt="Watch Out"
          width="125px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/watchout?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2025-09-11/yk13j91m/sudoku.jpg?w=300"
          alt="sudoku"
          width="136px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/sudoku?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={`${styles["game-card"]} ${styles["game-card-column"]} ${styles["game-card-grid"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2025-09-10/esnvqfuq/solvalam2x.png?w=300"
          alt="sudoku"
          width="92px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/word-coach?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      {/* <div className={`${styles["game-card-column"]} ${styles["game-card-grid"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2025-12-06/vmkmyapx/VikatanSolThedallogo.png?w=300"
          alt="sudoku"
          width="92px"
          height="22px"
        />
        <Link href="https://games.vikatan.com/solthedal?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div> */}
    </div>
  );
}

Gamessection.propTypes = {
  className: PropTypes.string
};
